import { IEntity } from '../types';

export function arrayShuffle<T extends IEntity>(items: T[]): T[] {
  return items
    .map((item) => ({ item, order: Math.random() }))
    .sort((a, b) => a.order - b.order)
    .map(({ item }) => item);
}
